import { render } from "./FileBaseMultiUploadRedesigned.vue?vue&type=template&id=72c05780&scoped=true"
import script from "./FileBaseMultiUploadRedesigned.vue?vue&type=script&lang=js"
export * from "./FileBaseMultiUploadRedesigned.vue?vue&type=script&lang=js"

import "./FileBaseMultiUploadRedesigned.vue?vue&type=style&index=0&id=72c05780&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c05780"]])

export default __exports__